import { DocumentsAttachments } from '../components';

export const WorkerDocuments = () => {
  return (
    <div className="sm:col-span-3">
      <dt className="sr-only text-sm font-medium text-ebony-clay-500">Attachments</dt>
      <dd className="text-sm text-ebony-clay-900">
        <DocumentsAttachments />
      </dd>
    </div>
  );
};
